import { FC, Fragment } from "react";
import { InfrastructureArchitectureHierarchyItem } from "@/components/pages/infrastructure-architecture/components/select-panel/body/hierarchy/InfrastructureArchitectureHierarchyItem";
import { formatServiceName } from "@/store/infrastructure-architecture/utils/helpers/formatServiceName";
import { formatSnakeCase } from "@/store/infrastructure-architecture/utils/helpers/formatSnakeCase";

interface InfrastructureArchitectureHierarchySwitchProps {
  hierarchy?: any;
  hierarchyLevel: number;
}

export const InfrastructureArchitectureHierarchySwitch: FC<
  InfrastructureArchitectureHierarchySwitchProps
> = ({ hierarchy, hierarchyLevel }) => {
  const isResourceArray = Array.isArray(hierarchy);

  if (!hierarchy) {
    return null;
  }

  return Object.entries(hierarchy ?? {}).map(
    ([type, childHierarchy]: [string, any]) => {
      if (typeof childHierarchy !== "object") {
        return null;
      }

      // Service
      if (childHierarchy?.id) {
        return (
          <InfrastructureArchitectureHierarchyItem
            key={type}
            resourceName={type}
            resourceLabel="Service"
            hierarchy={childHierarchy}
            hierarchyLevel={hierarchyLevel + 1}
          />
        );
      }

      // Resources Type
      if (Array.isArray(childHierarchy)) {
        return (
          <InfrastructureArchitectureHierarchyItem
            key={type}
            hierarchy={childHierarchy}
            resourceLabel="Resource Type"
            hierarchyLevel={hierarchyLevel + 1}
            resourceName={formatServiceName(type)}
          />
        );
      }

      // Resource
      if (isResourceArray) {
        return (
          <InfrastructureArchitectureHierarchyItem
            key={type}
            resourceLabel="Resource"
            hierarchyLevel={hierarchyLevel + 1}
            resourceName={childHierarchy?.resourceId}
          />
        );
      }

      // VPCs, subnets, Non VPC Resources, VPC Levels
      return (
        <Fragment key={type}>
          {Object.entries(childHierarchy).map(
            ([name, subValue]: [string, any]) => {
              if (name === "id") {
                return;
              }

              return (
                <InfrastructureArchitectureHierarchyItem
                  key={name}
                  resourceName={name}
                  hierarchy={subValue}
                  hierarchyLevel={hierarchyLevel + 1}
                  resourceLabel={formatSnakeCase(type)}
                />
              );
            },
          )}
        </Fragment>
      );
    },
  );
};
